import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import theme from '@theme/FolxTheme';

interface IListOptionWrapperProps {
	children: ReactNode;
}

const ListOption = styled.div`
	border-bottom: 1px solid ${theme.colors.borderGray};
	padding: 1.8rem ${theme.spacing.xssm} 1.8rem 0;
`;

const ListOptionWrapper: FC<IListOptionWrapperProps> = ({ children }) => {
	return <ListOption>{children}</ListOption>;
};

export default styled(ListOptionWrapper)``;
